/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForOutletScreen,
    GetFactoriesByGroupIDFromOutletScreen,
    SaveFactoriesFromOutletScreen,
    GetFactoriesByFactoryIDFromOutletScreen,
    UpdateFactoryDetailsFromOutletScreen,
    GetGradeByGroupID,
    GetAllRoutesDetails,
    GetAllCustomerTypes,
    GetMappedRoutesForOutlet,
    GetOrderConfigurationsByFactoryID,
    GetOutletCode,
    GetProvinceForDropdown,
    GetDistrictForDropdown,
    GetCityForDropdown,
    GetDsDivisionsForDropdown,
    GetGnDivisionsForDropdown
};

async function SaveFactoriesFromOutletScreen(requestModel) {
    let model = {
        groupID: requestModel.groupID,
        factoryCode: requestModel.factoryCode,
        gradeID: requestModel.gradeID,
        customerTypeID: requestModel.customerTypeID,
        erimsOutletCode: requestModel.erimsOutletCode,
        factoryName: requestModel.factoryName,
        createdBy: requestModel.createdBy,
        isActive: requestModel.isActive,
        mappedOutlets: requestModel.linkedProducts,
        province: requestModel.province,
        district: requestModel.district,
        city: requestModel.city,
        dsDivisionID: requestModel.dsDivisionID,
        gnDivisionID: requestModel.gnDivisionID,
        address1: requestModel.address1,
        address2: requestModel.address2,
        mobileNumber: requestModel.mobileNumber,
        secondaryMobile: requestModel.secondaryMobile == "" ? 0 : parseInt(requestModel.secondaryMobile),
        email: (requestModel.email && requestModel.email.toString().trim() !== '') ? requestModel.email : null
    }
    const response = await CommonPost('/api/OutletScreen/SaveFactoriesFromOutletScreen', null, model);
    return response;
}

async function GetAllGroupsForOutletScreen() {
    const response = await CommonGet('/api/OutletScreen/GetAllGroupsForOutletScreen', null);
    return response.data;
}

async function GetFactoriesByGroupIDFromOutletScreen(groupID) {
    const response = await CommonGet('/api/OutletScreen/GetFactoriesByGroupIDFromOutletScreen', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFactoriesByFactoryIDFromOutletScreen(factoryID) {
    const response = await CommonGet('/api/OutletScreen/GetFactoriesByFactoryIDFromOutletScreen', 'factoryID=' + parseInt(factoryID));
    return response.data;
}
async function UpdateFactoryDetailsFromOutletScreen(requestModel) {
    let model = {
        // groupID: requestModel.groupID,
        // factoryCode: requestModel.factoryCode,
        // gradeID: requestModel.gradeID,
        // customerTypeID: requestModel.customerTypeID,
        // erimsOutletCode: requestModel.erimsOutletCode,
        // factoryName: requestModel.factoryName,
         factoryID: requestModel.factoryID,
         factoryType:requestModel.factoryType,
        // createdBy: requestModel.createdBy,
        // isActive: requestModel.isActive,
        // mappedOutlets: requestModel.linkedProducts
         groupID: requestModel.groupID,
        factoryCode: requestModel.factoryCode,
        gradeID: requestModel.gradeID,
        customerTypeID: requestModel.customerTypeID,
        erimsOutletCode: requestModel.erimsOutletCode,
        factoryName: requestModel.factoryName,
        createdBy: requestModel.createdBy,
        isActive: requestModel.isActive,
        mappedOutlets: requestModel.linkedProducts,
        province: requestModel.province,
        district: requestModel.district,
        city: requestModel.city,
        dsDivisionID: requestModel.dsDivisionID,
        gnDivisionID: requestModel.gnDivisionID,
        address1: requestModel.address1,
        address2: requestModel.address2,
        mobileNumber: requestModel.mobileNumber,
        secondaryMobile: requestModel.secondaryMobile == "" ? 0 : parseInt(requestModel.secondaryMobile),
        email: (requestModel.email && requestModel.email.toString().trim() !== '') ? requestModel.email : null
    }
    const response = await CommonPost('/api/OutletScreen/UpdateFactoriesFromOutletScreen', null, model);
    return response;
}

async function GetGradeByGroupID(groupID) {
    const response = await CommonGet('/api/OutletScreen/GetGradeByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}
async function GetAllRoutesDetails() {
    const response = await CommonGet('/api/Routes/GetAllRoutes', null);
    return response.data;
}

async function GetMappedRoutesForOutlet(factoryID) {
    const response = await CommonGet('/api/OutletScreen/GetMappedRoutesForOutlet', 'factoryID=' + parseInt(factoryID));
    return response.data;
}

async function GetOrderConfigurationsByFactoryID(factoryID) {
    const response = await CommonGet('/api/OutletScreen/GetOrderConfigurationsByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}
async function GetAllCustomerTypes() {
    const response = await CommonGet('/api/OutletScreen/GetAllCustomerTypes', null);
    return response.data;
}

async function GetOutletCode (){
    const response = await CommonGet('/api/OutletScreen/GetOutletCode', null);
    return response.data;
}

async function GetProvinceForDropdown() {
  const response = await CommonGet('/api/Province/GetAllProvince', null);
  return response.data;
}

async function GetDistrictForDropdown(provinceID) {
  const response = await CommonGet(
    '/api/District/GetAllDistrictByProvinceID',
    'provinceID=' + parseInt(provinceID)
  );
  return response.data;
}

async function GetCityForDropdown(provinceID, districtID) {
  const response = await CommonGet(
    '/api/City/GetCityByProvinceIDDistrictID',
    'provinceID=' + parseInt(provinceID) + '&' + 'districtID=' + parseInt(districtID)
  );
  return response.data;
}

async function GetDsDivisionsForDropdown(model) {
  const response = await CommonPost(
    '/api/City/GetDsDivisionsForDropdown', null, model);
  return response.data;
}

async function GetGnDivisionsForDropdown(model) {
  const response = await CommonPost(
    '/api/City/GetGnDivisionsForDropdown', null, model);
  return response.data;
}
